import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers, URLSearchParams, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import { map, filter, catchError, mergeMap } from 'rxjs/operators';
//import 'rxjs/add/operator/map';
//import 'rxjs/add/operator/catch';
import { hazardMaster } from '../Models/HazardMasterModel';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ResultModel } from '../Models/ResultModel';

@Injectable()
export class HazardServices {

  apiURL: string = "";

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    //this.apiURL = baseUrl + 'api/HazardMaster/';
    if (sessionStorage.getItem("BaseURL") != null && sessionStorage.getItem("BaseURL") != "") {
      this.apiURL = sessionStorage.getItem("BaseURL") || '';
      this.apiURL = this.apiURL + 'api/HazardMaster';
    }
  }

  GetHazardMaster(TokenKey: string): Observable<hazardMaster[]> {
    let fullAPIPath = this.apiURL + '/GetHazardMaster';
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Token': TokenKey
      })
    };
    return this.http.get<hazardMaster[]>(fullAPIPath, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetHazardMasterFindByUserID(TokenKey: string, UserID: number, IndustryId: number): Observable<hazardMaster[]> {
    let fullAPIPath = this.apiURL + '/GetHazardMasterFindByUserID/' + UserID + '/' + IndustryId;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Token': TokenKey
      })
    };
    return this.http.get<hazardMaster[]>(fullAPIPath, httpOptions)
      .pipe(catchError(this.handleError));
  }

  private extractData(res: Response) {
    let body = res.json();
    //console.log("extractData " + body);
    return body;
  }

  private handleError(error: Response | any) {
    console.error(error.message || error);
    return Observable.throw(error.status)
  }
}
